import { Component, Inject, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IwgSelect } from 'src/app/shared/models/iwgselect.model';
import { AssignmentService } from 'src/app/shared/services/assignment.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { IwgSelectService } from 'src/app/shared/services/iwgselect.service';
import { UserService } from 'src/app/shared/services/user.service';
import { AssignmentDialogComponent } from '../assignment-dialog/assignment-dialog.component';

@Component({
  selector: 'app-transfer-assignment',
  templateUrl: './transfer-assignment.component.html',
  styleUrls: ['./transfer-assignment.component.scss']
})
export class TransferAssignmentComponent implements OnInit {

  @ViewChild("assignmentStep1") assignmentStep1:NgForm;
  @ViewChild("assignmentStep2") assignmentStep2:NgForm;
  @ViewChild("assignmentStep3") assignmentStep3:NgForm;
  @ViewChild("assignmentStep4") assignmentStep4:NgForm;

  Ready:boolean = false;

  isTransferToAOR = true;

  serviceId:any = null;
  quoteId:any = null;
  managerId:any = null;
  workerId:any = null;
  existingAssignment:any = null;
  isExistingTransferAssignment:any = null;
  isEditFromDetails:any = null;
  myDate = new Date();
  WizardTitle = 'Engage a Worker';
  AssignmentLabel = 'Engagement';
  AssignmentLabelLC = 'engagement';
  PayAmountTitle = 'Amount';
  SelectWorkerTitle = 'Select Worker';
  WorkerLabel = 'Worker';
  jobDescriptionRequired = true;
  IsCompliance = false;
  ShowComplianceRegions = false;
  payStructureHelpText = 'Choose how the Contractor will be paid.';

  numberOfSteps = 3;
  US_EOR = false;
  allowEndClients =null;
  allowTeams = null;
  isFileUploadInProgress = false;

  existingAssignmentId = null;
  isLoading = false;
  maxSteps = 5;
  selectedStepIndex = 0;
  pageLoaded= false;

  ngAfterViewInit(){
    this.pageLoaded = true;
}

  step1 = {
      is_entity_in_country: false,       
      service_type_id: 1, 
      selectedManager:null,
      title:"",
      is_expat:null,
      expat_nationality:null,
      is_expat_visa_required:null,
      is_worker_in_country:null,
      selectedTeam:null,
      selectedQuote:null,
      selectedEndClient:null,
      selectedQuoteSimple:null,
      selectedStateCompliance:null,  
      selectedCountry:null,
      selectedWorker:null                        
  };
  step2 = {
      sowFileID:null,
      offerLetterFileID:null,
      is_offer_letter_sent: false,
      is_sow_allowed: false,             
      is_track_delivery_date: false,
      is_track_spend_allowed: false,
      maximum_spend: null,
      job_description_file_quote_id: null,
      external_identifier_label: '',
      sowFileName:"",
      offerLetterFileName:"",
      job_title:"",
      job_description:"",
      job_description_file:null,
      job_description_file_id:null,
      jobDescriptionFileName:null,
      jobDescriptionFileID:null,
      jobDescriptionFile:null,
      start_date:null,
      hours_per_week:null,
      estimated_end_date:null,
      time_for_notice:"",
      department:"",
      cost_center:"",
      offer_letter_file:null,
      offer_letter_file_id:null,
      sow_file:null,
      sow_file_id:null,
      external_identifier:null
  };
  step3 = {
      is_overtime_authorized: false,
      is_expenses_authorized: false,
      is_commission_authorized: false,
      is_bonus_authorized: false,
      fulltime: true,
      regular: true,
      exempt: false,
      hours_per_week:null,
      pay_rate:null,
      other_compensation:null,
      selectedPayRateType:{ID:'00000000-0000-0000-0000-000000000000',Name:null},
      selectedCurrency:null,
      selectedPayRateTypeStructure:{ID:'00000000-0000-0000-0000-000000000000',Name:null}
  };
  step4 = {
      is_travel_required: false,
      travel_locations : '',
      is_driving_required: false,
      is_equipment_provided: false,
      equipment_provided: '',
      is_working_from_home: false,
      worksite_street1:"",
      worksite_street2:"",
      worksite_city:"",
      worksite_postal_code:"",
      selectedCountry:null,
      selectedState:null
  };

  quotesSimple:IwgSelect[] = [];

  JobTitleLabel = "";
  JobTitleLabelLC="";
  preselectedQuoteId:any = null;
  Filter_ClientID = null;
  selectedWorkerID=null;
  selectedManagerID=null;

  expat_nationality_id = null;
  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";

  constructor(
    private router: Router,
    private download:DownloadService,
    private quote:IwgSelectService,
    private user:UserService,
    private assignmentService:AssignmentService,
    private downloadService:DownloadService,
    private dialogRef: MatDialogRef<AssignmentDialogComponent>,
    private toast:MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private data:{
      serviceId:any,
      quoteId:any,
      managerId:any,
      workerId:any,
      existingAssignment:any,
      isExistingTransferAssignment:any,
      isEditFromDetails:any
    }
  ) { 
    this.allowEndClients = user.getAllowEndClients();
    this.allowTeams = user.getAllowTeams();

    this.serviceId = data.serviceId;
    this.quoteId = data.quoteId;
    this.managerId = data.managerId;
    this.workerId = data.workerId;
    this.existingAssignment = data.existingAssignment;
    this.isExistingTransferAssignment = data.isExistingTransferAssignment;
    this.isEditFromDetails = data.isEditFromDetails;

    if (this.serviceId == 3) {            
      this.AssignmentLabel = 'Evaluation';
      this.AssignmentLabelLC = 'evaluation';
      this.JobTitleLabel = 'Service Type';
      this.JobTitleLabelLC = 'service type';
      this.WizardTitle = 'Evaluate a Contractor';
      this.PayAmountTitle = 'Total Project Amount';
      this.SelectWorkerTitle = 'Select Contractor';
      this.WorkerLabel = 'Contractor';            
      this.IsCompliance = true;
    }

  }

  ngOnInit(): void {
    if (this.existingAssignment) {
        if (this.existingAssignment.QuoteID && this.isExistingTransferAssignment) {
            this.preselectedQuoteId = this.existingAssignment.QuoteID;
        } else {
          
            this.preselectedQuoteId = this.quoteId;            
        }
        this.populateForm(this.existingAssignment);
    } else if (this.quoteId) {
        this.preselectedQuoteId = this.quoteId;
    }

 
    if (this.managerId) {
        this.selectedManagerID = this.managerId;
    }
    if (this.workerId) {
        this.selectedWorkerID = this.workerId;
    }
    this.loadQuotes();
  }
  getQuotesSimple(){
    return new Promise((resolve,reject)=>{

    })
  }
  loadQuotes(){
    this.quote.getQuotes({
      format_hint: 'price_list_drop_down',
      service_type_id: this.serviceId
    }).subscribe(
      data => {
        const quotes = data.data.Data;
        this.quotesSimple = data.data.Data;
        if (this.preselectedQuoteId){
          const q = quotes.find(quote => quote.ID == this.preselectedQuoteId);
          if (!q) {
              console.error('Could not find quote ID ' + this.preselectedQuoteId + ' in the list of quotes');
          }else{
            this.step1.selectedQuoteSimple = q;
            this.onselectedQuoteChange({value: q});
          }
        }
      },
      err => {
        console.log('Error :: ', err);
      }
    );
  }
  populateForm(existingAssignment:any){
    if (existingAssignment) {

        this.existingAssignmentId = existingAssignment.ID;
        if (this.isTransferToAOR && !this.isExistingTransferAssignment) {
        
          this.existingAssignmentId = null; 
         
        }
        this.step1.selectedQuote = existingAssignment.Quote;

        Object.assign(this.step1, {
            title: existingAssignment.Title,
            quote_id: existingAssignment.QuoteID,
            service_type_id: parseInt(existingAssignment.Service.ServiceTypeEnumID),
            manager_id: existingAssignment.Manager.ID,
            team_id: (existingAssignment.Team != null)? existingAssignment.Team.ID : 0,
            worker_id: existingAssignment.Worker.ID,
            is_entity_in_country: existingAssignment.EntityInCountry,
            country_id: existingAssignment.Country.ID
        });
        this.step1.selectedCountry = existingAssignment.Country;
        this.step1.selectedWorker = existingAssignment.Worker;
        this.step1.selectedManager = existingAssignment.Manager;
        this.step1.selectedTeam = existingAssignment.Team;
        if (existingAssignment.EndClient.ID != '00000000-0000-0000-0000-000000000000') {
            this.step1.selectedEndClient = existingAssignment.EndClient;
        } else {
            this.step1.selectedEndClient = 0;
        }
        if (this.step1.selectedCountry.HasRegions) {
            this.ShowComplianceRegions = true;
        }

        this.step1.selectedStateCompliance = existingAssignment.Region;

        Object.assign(this.step2, {
            job_title: existingAssignment.JobTitle,
            job_description: existingAssignment.JobDescription,

            job_description_file: existingAssignment.JobDescriptionFile.Name,
            job_description_file_id: existingAssignment.JobDescriptionFile.ID,

            start_date: new Date(existingAssignment.StartDate),
            estimated_end_date: existingAssignment.ExpectedEndDate ? new Date(existingAssignment.ExpectedEndDate) : null,
            department: existingAssignment.Department,
            cost_center: existingAssignment.CostCenter
        });

        if (existingAssignment.JobDescriptionFile) {
            if (existingAssignment.JobDescriptionFile.Name || existingAssignment.JobDescriptionFile.ID != '00000000-0000-0000-0000-000000000000') {
                this.jobDescriptionRequired = false; 
               
            }
            this.step2.jobDescriptionFileName = existingAssignment.JobDescriptionFile.Name;
            this.step2.jobDescriptionFileID = existingAssignment.JobDescriptionFile.ID;
        }

        if (existingAssignment.OfferLetterFile) {
            this.step2.offerLetterFileName = existingAssignment.OfferLetterFile.Name;
            this.step2.offerLetterFileID = existingAssignment.OfferLetterFile.ID;
        }

        if (existingAssignment.SOWFile) {
            this.step2.sowFileName = existingAssignment.SOWFile.Name;
            this.step2.sowFileID = existingAssignment.SOWFile.ID;
        }

        Object.assign(this.step3, {
            pay_rate: existingAssignment.PayRate,
            is_overtime_authorized: existingAssignment.IsOvertimeAuthorized,
            is_expenses_authorized: existingAssignment.IsExpensesAuthorized,
            is_commission_authorized: existingAssignment.IsCommissionAuthorized,
            is_bonus_authorized: existingAssignment.IsBonusAuthorized,
            other_compensation: existingAssignment.OtherCompensation,
            hours_per_week: existingAssignment.hours_per_week,
            fulltime: (existingAssignment.IsPT==true) ? false : true,
            regular: (existingAssignment.IsSporadic==true) ? false : true,
            exempt: existingAssignment.IsExempt,
        });

        this.step3.selectedCurrency = existingAssignment.PayCurrency;
        if(existingAssignment.PayRateTimeframe.ID != '00000000-0000-0000-0000-000000000000'){
          this.step3.selectedPayRateType = existingAssignment.PayRateTimeframe;
        }

        if(existingAssignment.PayRateTimeframeStructure.ID != '00000000-0000-0000-0000-000000000000'){
          this.step3.selectedPayRateTypeStructure = existingAssignment.PayRateTimeframeStructure;
        }

        Object.assign(this.step4, {
            is_travel_required: existingAssignment.IsTravelRequired,
            travel_locations: existingAssignment.TravelLocations,
            is_driving_required: existingAssignment.IsDrivingRequired,
            is_equipment_provided: existingAssignment.IsEquipmentProvided,
            equipment_provided: existingAssignment.EquipmentProvided,
            is_working_from_home: existingAssignment.IsWorkingFromHome,
            worksite_street1: existingAssignment.WorksiteAddress.StreetAddress1,
            worksite_street2: existingAssignment.WorksiteAddress.StreetAddress2,
            worksite_city: existingAssignment.WorksiteAddress.City,
            worksite_postal_code: existingAssignment.WorksiteAddress.PostalCode,
            worksite_country_id: existingAssignment.WorksiteAddress.Country.ID,
            worksite_state_id: existingAssignment.WorksiteAddress.Region.ID
        });

        this.step4.selectedCountry = existingAssignment.WorksiteAddress.Country;
        this.step4.selectedState = existingAssignment.WorksiteAddress.Region;

        this.SetAssignmentLabel();
        this.Ready = true;
    }
  }
  setContext(quote)
  {
      if (quote && quote.QuoteRequest_Service_Name != null)
      {
          this.US_EOR = false;                    
          if (quote.QuoteRequest_Country_Abbreviation == 'US' && quote.QuoteRequest_Service_Name.trim() == 'Employer of Record')
          {
              this.US_EOR = true;                    
          }
      }
      if (quote && quote.QuoteRequest_Service_Name != null) {
          if (quote.QuoteRequest_Service_Name.trim() == 'Compliance') {
              this.IsCompliance = true;
          }
      }
  }
  SetAssignmentLabel()
  {
      this.numberOfSteps = 4;
      this.JobTitleLabel= 'Job Title';
      this.JobTitleLabelLC= 'job title';
      this.AssignmentLabel= 'Assignment';
      this.AssignmentLabelLC = 'assignment';
      this.SelectWorkerTitle = 'Select Worker';
      this.WorkerLabel = 'Worker';
      this.PayAmountTitle = 'Amount';

      if (this.step1.service_type_id == 2) {
          this.WizardTitle = 'Engage a Contractor';
          this.SelectWorkerTitle = 'Select Contractor';
          this.WorkerLabel = 'Contractor';
          this.AssignmentLabel = 'Engagement';
          this.AssignmentLabelLC = 'engagement';
          this.JobTitleLabel = 'Service Type';
          this.JobTitleLabelLC = 'service type';
          this.PayAmountTitle = 'Total Project Amount';
          this.numberOfSteps = 3;
         
      }
      if (this.step1.service_type_id == 3 || this.serviceId == 3) {
          this.AssignmentLabel = 'Evaluation';
          this.AssignmentLabelLC = 'evaluation';
          this.JobTitleLabel = 'Service Type';
          this.JobTitleLabelLC = 'service type';
          this.WizardTitle = 'Evaluate a Contractor';
          this.SelectWorkerTitle = 'Select Contractor';
          this.WorkerLabel = 'Contractor';
          this.PayAmountTitle = 'Total Project Amount';
          this.IsCompliance = true;
          this.numberOfSteps = 3;
        
          this.step3.selectedPayRateType = { 'ID': 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075', 'Name': null };
      }
  }
  prepopulateQuoteFields(quote) {         
    if (quote && quote.QuoteRequest_Service_ServiceTypeEnumID != null) {
        this.setContext(quote);     
        this.step1.is_entity_in_country = quote.QuoteRequest_DoesCompanyHaveBusinessEntityInCountry;
        this.step1.service_type_id = parseInt(quote.QuoteRequest_Service_ServiceTypeEnumID);
        
       
        this.SetAssignmentLabel();
        this.Ready = true;                

    } else {
        console.error('No quote request');
    }
  }

  onselectedQuoteChange(selected){
    let d = selected.value;
    this.quote.getSingleQuote(d.ID).subscribe(
      data=>{
        if(data.apiCallStatus != 1 ){
          return;
        }
        this.step1.selectedQuote = data.data.Data;
        if (parseInt(data.data.Data.QuoteRequest_Service_ServiceTypeEnumID) == 1) {
           
        
        } else {
          
        }
        
       
        if (!this.existingAssignmentId) {
            this.prepopulateQuoteFields(data.data.Data);
        }
        else
        {
            this.setContext(data.data.Data);
        }
      },
      err=>{
        console.log("Error :: ",err)
      }
    )
  }

  nextStep(): void {
    let canProceed = false;
    let stepIndex = this.selectedStepIndex + 1;
    switch (stepIndex) {
      case 1:
          canProceed = this.assignmentStep1.valid;
          if (this.step1.service_type_id == 3 && this.step1.selectedStateCompliance == null && this.step4.selectedCountry.HasRegions == true) {
              alert('Please select a state or region');
              canProceed = false;
          }
          break;
      case 2:
          canProceed = this.assignmentStep2.valid;
          break;
      case 3:                    
          canProceed = this.assignmentStep3.valid;
          break;
      case 4:
          canProceed = this.assignmentStep4.valid;
         
          if (this.step4.selectedState==null && this.step4.selectedCountry.HasRegions == true)
          {
              alert('Please select a state or region for the worksite');
              canProceed = false;
          }
          break;
      case -1:                    
          canProceed = true;
          break;
    }
    if (canProceed) {
      let index = (this.selectedStepIndex == this.maxSteps) ? 0 : this.selectedStepIndex + 1;
      this.saveDraft().then(data=>{
        if (index == 3 && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3)) { index = 4; }
      
        this.selectedStepIndex = index;
      })
    }
    this.resetFileErrorMessages();

  }
  resetFileErrorMessages() {
  
  }

  prevStep(): void {
    this.resetFileErrorMessages();
    this.selectedStepIndex -= 1;
    if (this.selectedStepIndex == 3 && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3)) { this.selectedStepIndex = 2; }
  }
  saveDraft() {            
  
      const statusId = 1;
      return this.save(statusId);
  }
  save(statusId) {
    this.isLoading = true;
    let props = {
      request_from_client_portal: true,
      new_status_id: statusId
    };
    if(this.assignmentStep1.valid){
      var CountryID = 0;
      var EntityInCountry = false;
      if (this.step1.selectedCountry != null)
      {       
          CountryID = this.step1.selectedCountry.ID;
      }                
      if (this.step1.is_entity_in_country != null)
      {
          EntityInCountry = this.step1.is_entity_in_country;
      }
      if (this.isTransferToAOR) {
        this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID = 2;
        
    }
      let obj1 = {
        title: this.step1.title,                    
        end_client_id: (this.step1.selectedEndClient != null)? this.step1.selectedEndClient.ID : 0,                    
        quote_id: this.step1.selectedQuoteSimple.ID,
        service_type_id: parseInt(this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID),                    
        manager_id: this.step1.selectedManager.ID,
       
        team_id: (this.step1.selectedTeam != null) ? this.step1.selectedTeam.ID : 0,                          
        is_entity_in_country: EntityInCountry,
        worker_id: this.step1.selectedWorker.ID,
       
        country_id: CountryID,
        job_description_file_quote_id: this.step2.job_description_file_quote_id,
        worksite_country_id: this.step4.selectedCountry.ID,
                          
        is_transfer_to_AOR: (this.isTransferToAOR == true) ? true : null,
        transfer_evaluation_ID: this.existingAssignment.DisplayID,
        start_date: this.step2.start_date,
        estimated_end_date: this.step2.estimated_end_date,
        department: this.step2.department,
        cost_center: this.step2.cost_center,
        job_title: this.step2.job_title,
        job_description: this.step2.job_description,
        job_description_file: this.step2.job_description_file,
        job_description_file_id: this.step2.job_description_file_id,
        pay_rate: this.step3.pay_rate,
        pay_rate_type_id: (this.step1.service_type_id == 3) ? 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075' : this.step3.selectedPayRateType.ID,
        pay_rate_type_structure_id: (this.step3.selectedPayRateTypeStructure == null) ? 0 : this.step3.selectedPayRateTypeStructure.ID  
      }
      Object.assign(props,obj1);
      if ((this.step1.service_type_id == 3 || this.step1.service_type_id == 2) && this.step1.selectedStateCompliance) {
          Object.assign(props,{worksite_state_id: this.step1.selectedStateCompliance.ID});
      }
    }
    if(this.assignmentStep2.valid){
      Object.assign(props,{
        is_offer_letter_sent: this.step2.is_offer_letter_sent,                    
        job_title: this.step2.job_title,
        job_description: this.step2.job_description,
        maximum_spend: this.step2.maximum_spend,

        job_description_file: this.step2.job_description_file,
        job_description_file_id: this.step2.job_description_file_id,
        offer_letter_file: this.step2.offer_letter_file,
        offer_letter_file_id: this.step2.offer_letter_file_id,
        sow_file: this.step2.sow_file,
        sow_file_id: this.step2.sow_file_id,

        start_date: this.step2.start_date,
        estimated_end_date: this.step2.estimated_end_date,
        department: this.step2.department,
        cost_center: this.step2.cost_center,
        time_for_notice: this.step2.time_for_notice                    
      });
    }
    if (this.step1.service_type_id == 1 || this.step1.service_type_id == 2 || this.step1.service_type_id == 3)
    {                
      if (this.assignmentStep3.valid) {
        Object.assign(props, {
          pay_rate: this.step3.pay_rate,
          pay_rate_type_id: (this.step1.service_type_id == 3) ? 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075' :  this.step3.selectedPayRateType.ID,
          pay_rate_type_structure_id: (this.step3.selectedPayRateTypeStructure==null)? 0:  this.step3.selectedPayRateTypeStructure.ID,
          currency_id: this.step3.selectedCurrency.ID,
          is_overtime_authorized: this.step3.is_overtime_authorized,
          is_expenses_authorized: this.step3.is_expenses_authorized,
          is_commission_authorized: this.step3.is_commission_authorized,
          is_bonus_authorized: this.step3.is_bonus_authorized,
          other_compensation: this.step3.other_compensation,
          weekly_hours: this.step3.hours_per_week,
          is_part_time: !this.step3.fulltime,
          regular: this.step3.regular,
          fulltime: this.step3.fulltime,
          exempt: this.step3.exempt,
      });
      }
    }
    if (this.step1.service_type_id == 1)
    {
        if (this.assignmentStep4.valid) {
            Object.assign(props, {
                is_travel_required: this.step4.is_travel_required,
                travel_locations: this.step4.travel_locations,
                is_driving_required: this.step4.is_driving_required,
                is_equipment_provided: this.step4.is_equipment_provided,
                equipment_provided: this.step4.equipment_provided,

                is_working_from_home: this.step4.is_working_from_home,

                worksite_street1: this.step4.worksite_street1,
                worksite_street2: this.step4.worksite_street2,
                worksite_city: this.step4.worksite_city,
                worksite_postal_code: this.step4.worksite_postal_code,
                worksite_country_id: this.step4.selectedCountry.ID,                    
            });

            if (this.step4.selectedState) {
                Object.assign(props, {
                    worksite_state_id: this.step4.selectedState.ID,
                });
            }
        }                
    }
    if (this.existingAssignmentId) {
      return this.assignmentService.update(this.existingAssignmentId,props)
      .toPromise()
      .then(data=>{this.onSaveSuccess(data);return data;})
      .catch(err=>this.onSaveError(err));
    } else {  
      return  this.assignmentService.save(props)
      .toPromise()
      .then(data=>{this.onSaveSuccess(data);return data;})
      .catch(err=>this.onSaveError(err));
    }

  }
  onSaveSuccess(response){    
    this.isLoading = false;
    let data = response.data;
    if(response.apiCallStatus==1){     
      this.existingAssignmentId = data.Data?data.Data.ID:null;
    
          if (data.ErrorCode != 200) {
      }
      // Let everyone know that there has been a change

      this.updateFormFields();
                  
     
    }
  }
  onSaveError(error){
    this.isLoading = false;
    console.error(error);
  }

  updateFormFields() { 
    this.assignmentService.getAssignmentById(this.existingAssignmentId)
    .subscribe(
      updatedAssignment=>{
        if (updatedAssignment.data.ErrorCode != 200){
          return;
        }
        updatedAssignment = updatedAssignment.data.Data;
        if (updatedAssignment.JobDescriptionFile) {                      
            this.step2.job_description_file = updatedAssignment.JobDescriptionFile.Name;
            this.step2.job_description_file_id = updatedAssignment.JobDescriptionFile.ID                                                                                
        }     
        if (updatedAssignment.OfferLetterFile) {                    
            this.step2.offer_letter_file = updatedAssignment.OfferLetterFile.Name;
            this.step2.offer_letter_file_id = updatedAssignment.OfferLetterFile.ID                                                                                
        }                  

        if (updatedAssignment.SOWFile) {                    
            this.step2.sow_file = updatedAssignment.SOWFile.Name;
            this.step2.sow_file_id = updatedAssignment.SOWFile.ID                                                                                                    
        }                  

        this.step2.is_sow_allowed = updatedAssignment.AllowSOWUpload;
        this.step2.is_track_delivery_date = updatedAssignment.TrackDeliveryDate;    
        this.step2.is_track_spend_allowed = false;   
      }
    )                                
  }
  submit(){
    const statusId = 2;
    this.save(statusId).then((response:any) => {     
      response = response.data;
      if (response.ErrorCode == 200) {
          this.dialogRef.close();
          if (this.step1.service_type_id == 2)
          {
              this.showConfirmationToast('Thank you! The engagement is pending onboarding.');
          }
          else if (this.step1.service_type_id == 3) {
              this.showConfirmationToast('Thank you! The evaluation will be started.');
          }
          else
          {
              this.showConfirmationToast('Thank you! We will respond to your request within 1 business day.');
          }


         
          let redirectToServicePage = 1;

          if (this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID != null) {
              redirectToServicePage = this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID;
          }
          this.router.navigate(["assignments"],{queryParams:{service: redirectToServicePage}});
      } else {
          this.showConfirmationToast('Error submitting form.');
         
      }
    })
  }
  saveAsDraft(){
    this.saveDraft().then((response:any)=>{
      if (response.data.ErrorCode == 200) {
          this.dialogRef.close();
          this.showConfirmationToast('Draft has been saved.');
          if (this.isEditFromDetails == true) {
             
          }else{
            this.router.navigate(["assignments"],{queryParams:{service: 2}});
          }
      } else {
          this.showConfirmationToast('Error saving draft.');
      }
    })
    .catch(err=>{console.log(err)})
  }
  checkF(){
    let step = this.selectedStepIndex + 1;    
  }
  canProceed(){
    let step = this.selectedStepIndex + 1;
    let valid = false;
    
    if (this['assignmentStep' + step]) {
        valid = this['assignmentStep' + step].valid;       
    }
    if (step == 1 && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3) && this.step1.selectedStateCompliance == null && this.step4.selectedCountry.HasRegions == true) {  
      valid = false;
    }

  
    if (this.step1.service_type_id == 3 && step >= 4) {
      valid = true;
    }

    return valid;
  }
  showConfirmationToast(text){
    this.toast.open(text, "Got it", {
      duration: 2000,horizontalPosition:this.Hposition,
      verticalPosition:this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }
  cancel(isDraft){
    this.dialogRef.close();
    if(isDraft){
      this.showConfirmationToast('Draft has been saved.');
    }
    if (this.isEditFromDetails == true) {
    }
    else {
      if (isDraft) {
          this.router.navigate(["assignments"],{queryParams:{service: 2}});
      }
    }
  }
  downloadJobDescriptionFile(){
    this.downloadService.saveAs('/Api/File/' + this.step2.job_description_file_id);
  }
  downloadSOWFile(){
    this.downloadService.saveAs('/Api/File/' + this.step2.sow_file_id);
  }
  downloadOfferLetterFile(){
    this.downloadService.saveAs('/Api/File/' + this.step2.offer_letter_file_id);
  }
  isTransfer(){
    if (this.isTransferToAOR) {
      return true;
    }
    return false;
  }
}
